module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="form-horizontal" id="insertInstanceForm">\r\n  <div class="modal-dialog modal-lg" role="document">\r\n    <div class="modal-content">\r\n\r\n      <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n        <h2 class="modal-title" id="myModalLabel">';
if(!attributes.id){print(lang.INSERT_INSTANCE);} else {print(lang.EDIT_INSTANCE);}
__p+='</h2>\r\n      </div>\r\n      <div class="modal-body">\r\n\r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="name">'+
((__t=(lang.NAME))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-9 col-xs-12">\r\n                <input type="text" class="form-control"  id="name" placeholder="'+
((__t=(lang.NAME))==null?'':_.escape(__t))+
'" required value="'+
((__t=(attributes.name))==null?'':_.escape(__t))+
'">\r\n            </div>\r\n        </div>\r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="start">'+
((__t=(lang.START))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-4 col-xs-12">\r\n                <div class=\'input-group\' id=\'dtpickerStart\'>\r\n                    <input type=\'text\' id="start" name="start" class="form-control date" required value="'+
((__t=(attributes.start))==null?'':_.escape(__t))+
'" />\r\n                    <span class="input-group-addon">\r\n                        <span class="glyphicon glyphicon-calendar"></span>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="end">'+
((__t=(lang.END))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-4 col-xs-12">\r\n                <div class=\'input-group\' id=\'dtpickerEnd\'>\r\n                    <input type=\'text\' id="end" name="end" class="form-control date" required value="'+
((__t=(attributes.end))==null?'':_.escape(__t))+
'" />\r\n                    <span class="input-group-addon">\r\n                        <span class="glyphicon glyphicon-calendar"></span>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="maxUsers">'+
((__t=(lang.MAX_USERS))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-4 col-xs-12">\r\n                <input type="number" class="form-control"  id="maxUsers" placeholder="'+
((__t=(lang.MAX_USERS))==null?'':_.escape(__t))+
'" required value="'+
((__t=(attributes.maxUsers))==null?'':_.escape(__t))+
'">\r\n            </div>\r\n        </div>\r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="payment">'+
((__t=(lang.PAYMENT))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-4 col-xs-12">\r\n                <select id="payment" name="payment" class="form-control">\r\n                    ';
if(!attributes.id){
                        attributes.payment=0;
                    }
__p+='\r\n                    <option value="0" '+
((__t=(attributes.payment===0?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.MONTHLY))==null?'':_.escape(__t))+
'</option>\r\n                    <option value="1" '+
((__t=(attributes.payment===1?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.T_MONTHLY))==null?'':_.escape(__t))+
'</option>\r\n                    <option value="2" '+
((__t=(attributes.payment===2?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.YEARLY))==null?'':_.escape(__t))+
'</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="price">'+
((__t=(lang.PRICE))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-4 col-xs-12">\r\n                    <input type="number" step="0.01" class="form-control" id="price" placeholder="'+
((__t=(lang.PRICE))==null?'':_.escape(__t))+
'" required value="'+
((__t=(attributes.price))==null?'':_.escape(__t))+
'">\r\n            </div>\r\n        </div> \r\n        <div class="col-md-12 form-group">\r\n            <div class="col-md-3 col-xs-12 text-right">\r\n                <label class="control-label" for="paymentEnv">'+
((__t=(lang.PAYMENT_ENV))==null?'':_.escape(__t))+
':</label>\r\n            </div>\r\n            <div class="col-md-4 col-xs-12">\r\n                <select id="paymentEnv" name="paymentEnv" class="form-control">\r\n                        ';
if(!attributes.id){
                            attributes.paymentEnv=0;
                        }
__p+='\r\n                        <option value="0" '+
((__t=(attributes.paymentEnv===0?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.MONTHLY))==null?'':_.escape(__t))+
'</option>\r\n                        <option value="1" '+
((__t=(attributes.paymentEnv===1?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.T_MONTHLY))==null?'':_.escape(__t))+
'</option>\r\n                        <option value="2" '+
((__t=(attributes.paymentEnv===2?'selected':''))==null?'':_.escape(__t))+
'>'+
((__t=(lang.YEARLY))==null?'':_.escape(__t))+
'</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="clear"></div>\r\n      </div>\r\n\r\n      <div class="modal-footer">\r\n        <div class="col-xs-4">\r\n            ';
if(attributes.id){
                //print('<button type="submit" class="btn btn-danger" id="delete">+lang.DELETE+</button>');
            }
__p+='\r\n        </div>\r\n        <div class="col-xs-8 text-right">\r\n            <button type="submit" class="btn btn-primary" id="post">'+
((__t=(lang.SAVE))==null?'':_.escape(__t))+
'</button>\r\n            <button type="reset" class="btn btn-default" id="cancel">'+
((__t=(lang.ABANDON))==null?'':_.escape(__t))+
'</button>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</form>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/companies/insertCompanyView.ejs
// module id = 415
// module chunks = 0